import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { reisenApi } from '../api';

export default function ReisenPage() {
  const [reisen, setReisen] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', ziel: '', startdatum: '', enddatum: '', notizen: '' });
  const navigate = useNavigate();

  const load = () => reisenApi.list().then(res => setReisen(res.data));
  useEffect(() => { load(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    await reisenApi.add(form);
    setForm({ name: '', ziel: '', startdatum: '', enddatum: '', notizen: '' });
    setShowForm(false);
    load();
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Reise "${name}" löschen?`)) return;
    await reisenApi.delete(id);
    load();
  };

  const statusColor = (s) => ({ geplant: '#0ea5e9', aktiv: '#10b981', abgeschlossen: '#64748b' }[s] || '#64748b');
  const statusLabel = (s) => ({ geplant: '📅 Geplant', aktiv: '✈️ Aktiv', abgeschlossen: '✅ Abgeschlossen' }[s] || s);

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', padding: 16 }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>

        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <h1 style={{ color: '#f1f5f9', fontSize: 22, fontWeight: 700 }}>✈️ Meine Reisen</h1>
            <p style={{ color: '#64748b', fontSize: 13 }}>{reisen.length} Reise(n)</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => navigate('/master')} style={headerBtn}>📋 Master-Liste</button>
            <button onClick={() => setShowForm(!showForm)} style={{ ...headerBtn, background: '#0ea5e9', color: 'white' }}>
              {showForm ? '✕' : '+ Neue Reise'}
            </button>
          </div>
        </div>

        {/* Neue Reise Form */}
        {showForm && (
          <form onSubmit={handleAdd} style={{ background: '#1e293b', borderRadius: 12, padding: 16, marginBottom: 16 }}>
            <h3 style={{ color: '#94a3b8', fontSize: 12, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1, marginBottom: 12 }}>✈️ Neue Reise</h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <input value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))}
                placeholder="Reisename *" required style={inputStyle} />
              <input value={form.ziel} onChange={e => setForm(p => ({ ...p, ziel: e.target.value }))}
                placeholder="Reiseziel (z.B. Hurghada, Ägypten)" style={inputStyle} />
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
                <input type="date" value={form.startdatum} onChange={e => setForm(p => ({ ...p, startdatum: e.target.value }))} style={inputStyle} />
                <input type="date" value={form.enddatum} onChange={e => setForm(p => ({ ...p, enddatum: e.target.value }))} style={inputStyle} />
              </div>
              <textarea value={form.notizen} onChange={e => setForm(p => ({ ...p, notizen: e.target.value }))}
                placeholder="Notizen..." rows={2} style={{ ...inputStyle, resize: 'vertical' }} />
              <button type="submit" style={{ background: '#0ea5e9', color: 'white', border: 'none', padding: '10px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' }}>
                ✅ Reise anlegen
              </button>
            </div>
          </form>
        )}

        {/* Reisen Liste */}
        {reisen.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>
            <div style={{ fontSize: 48, marginBottom: 12 }}>✈️</div>
            <p>Noch keine Reisen geplant</p>
            <p style={{ fontSize: 13, marginTop: 8 }}>Klicke "+ Neue Reise" um zu starten</p>
          </div>
        ) : (
          reisen.map(r => (
            <div key={r.id} onClick={() => navigate(`/reise/${r.id}`)}
              style={{ background: '#1e293b', borderRadius: 12, padding: 16, marginBottom: 12, cursor: 'pointer', border: '1px solid #334155' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ color: '#f1f5f9', fontWeight: 700, fontSize: 16, marginBottom: 4 }}>
                    ✈️ {r.name}
                  </div>
                  {r.ziel && <div style={{ color: '#94a3b8', fontSize: 13 }}>📍 {r.ziel}</div>}
                  {r.startdatum && (
                    <div style={{ color: '#64748b', fontSize: 12, marginTop: 4 }}>
                      📅 {new Date(r.startdatum).toLocaleDateString('de-DE')}
                      {r.enddatum && ` – ${new Date(r.enddatum).toLocaleDateString('de-DE')}`}
                    </div>
                  )}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 8 }}>
                  <span style={{ background: statusColor(r.status) + '22', color: statusColor(r.status), padding: '3px 8px', borderRadius: 8, fontSize: 11, fontWeight: 600 }}>
                    {statusLabel(r.status)}
                  </span>
                  <button onClick={e => { e.stopPropagation(); handleDelete(r.id, r.name); }}
                    style={{ background: '#ef444422', color: '#f87171', border: 'none', padding: '4px 8px', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}>
                    🗑️
                  </button>
                </div>
              </div>
            </div>
          ))
        )}

        <div style={{ textAlign: 'center', marginTop: 20 }}>
          <button onClick={() => { localStorage.removeItem('packliste_token'); window.location.href = '/login'; }}
            style={{ background: 'none', border: 'none', color: '#64748b', cursor: 'pointer', fontSize: 13 }}>
            Abmelden
          </button>
        </div>
      </div>
    </div>
  );
}
const inputStyle = { background: '#0f172a', border: '1px solid #334155', color: '#f1f5f9', padding: '10px 12px', borderRadius: 8, fontSize: 14, outline: 'none', width: '100%' };
const headerBtn = { background: '#1e293b', color: '#94a3b8', border: '1px solid #334155', padding: '8px 12px', borderRadius: 8, cursor: 'pointer', fontSize: 13, fontWeight: 600 };
